// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@conklin/Overrides/Pages/Header";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, companyLogoItem, layoutContainer, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

headerStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        display: block;
        margin: 0px auto;
        width: 100%;
        max-width: 100%;
        position: sticky;
        top: 0px;
        z-index: ${getProp("theme.zIndex.header")};
        border-bottom: 4px solid ${color("primary")};
        max-height: 200px;

        ${xScreen("lte", "md")} {
            position: sticky;
        }

        ${xScreen("lte", "sm")} {
            position: sticky;
        }

        ${xScreen("gte", 1025)} {
            &.hide {
                visibility: hidden;
                opacity: 0;
            }
        }
    `,
};

headerStyles.container = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        column-gap: 32px;
        padding: 12px 16px;
        ${layoutContainer}

        ${({ isCheckoutPage }: any) =>
            isCheckoutPage &&
            css`
                padding: 4px 16px;
            `}

        ${xScreen("lte", "md")} {
            column-gap: 24px;
            padding: unset;
            height: 56px;
        }
    `,
};

headerStyles.topSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        column-gap: 32px;
    `,
};

headerStyles.leftSection = {
    css: css`
        flex: 0 0 157px;

        ${({ isHidden }: any) =>
            isHidden &&
            css`
                && {
                    display: none;
                }
            `}

        ${({ isCheckoutPage }: any) =>
            isCheckoutPage &&
            css`
                flex: 0 0 63px;
            `}

        ${xScreen("lte", "md")} {
            flex: 0 0 123px;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            column-gap: 24px;
        }
    `,
};

headerStyles.rightSection = {
    css: css`
        flex: 1;
        display: flex;
        flex-direction: column;
        row-gap: 12px;
        justify-content: center;
    `,
};

headerStyles.headerMessage = {
    size: 12,
    lineHeight: "15px",
    weight: fontConfig.weight.regular,
    italic: true,
    forwardAs: "span",
    css: css`
        white-space: nowrap;
        margin-right: auto;
    `,
};

headerStyles.topRightSection = {
    css: css`
        & > div {
            display: flex;
            justify-content: flex-end;
            flex-wrap: nowrap;
            column-gap: 32px;
        }
    `,
};

headerStyles.printLogo = {
    ...mergeWithCss(companyLogoItem, {
        css: css`
            height: 120px;
            text-align: center;
            img {
                position: absolute;
                top: 12px;
                left: 50%;
                transform: translate(-50%, 0);
                z-index: 1;
                max-width: 100px;
            }
        `,
    }),
};
